<template>
	<div
		class="p-6 transition-all duration-500 border shadow-xl sm:p-8 lg:p-10 sm:shadow-2xl bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl border-white/40 hover:shadow-blue-500/10 animate-fade-in-up"
	>
		<div class="mb-6 text-center sm:mb-8">
			<h2 class="mb-3 text-2xl font-bold sm:text-3xl text-slate-900">
				Choose Your Commercial Cover Type
			</h2>
			<p class="max-w-2xl mx-auto text-base sm:text-lg text-slate-600">
				Select the type of insurance coverage for your commercial
				vehicle
			</p>
		</div>

		<div
			class="grid max-w-2xl grid-cols-1 gap-4 mx-auto sm:gap-5 sm:grid-cols-2"
		>
			<div
				@click="selectCover('comprehensive-commercial')"
				:class="[
					'relative overflow-hidden transition-all duration-500 bg-white border shadow-sm group rounded-xl p-5 sm:p-6 cursor-pointer hover:shadow-lg',
					selectedCoverType === 'comprehensive-commercial'
						? 'border-blue-600 shadow-md ring-2 ring-blue-600/20'
						: 'border-slate-100 hover:border-slate-200',
				]"
			>
				<div class="flex items-start justify-between mb-2">
					<h4
						class="text-xl font-bold leading-tight sm:text-2xl text-slate-900"
					>
						Comprehensive Commercial Cover
					</h4>
					<div
						v-if="selectedCoverType === 'comprehensive-commercial'"
						class="flex-shrink-0 ml-2 text-blue-600"
					>
						<svg
							class="w-5 h-5 sm:w-6 sm:h-6"
							fill="currentColor"
							viewBox="0 0 20 20"
						>
							<path
								fill-rule="evenodd"
								d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
								clip-rule="evenodd"
							></path>
						</svg>
					</div>
				</div>
				<p class="text-sm leading-relaxed sm:text-base text-slate-600">
					Provides extensive protection for your commercial vehicle,
					including own vehicle damage, theft, fire, and third-party
					liabilities.
				</p>
			</div>

			<div
				@click="selectCover('third-party-commercial')"
				:class="[
					'relative overflow-hidden transition-all duration-500 bg-white border shadow-sm group rounded-xl p-5 sm:p-6 cursor-pointer hover:shadow-lg',
					selectedCoverType === 'third-party-commercial'
						? 'border-blue-600 shadow-md ring-2 ring-blue-600/20'
						: 'border-slate-100 hover:border-slate-200',
				]"
			>
				<div class="flex items-start justify-between mb-2">
					<h4
						class="text-xl font-bold leading-tight sm:text-2xl text-slate-900"
					>
						Third Party Commercial Only
					</h4>
					<div
						v-if="selectedCoverType === 'third-party-commercial'"
						class="flex-shrink-0 ml-2 text-blue-600"
					>
						<svg
							class="w-5 h-5 sm:w-6 sm:h-6"
							fill="currentColor"
							viewBox="0 0 20 20"
						>
							<path
								fill-rule="evenodd"
								d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
								clip-rule="evenodd"
							></path>
						</svg>
					</div>
				</div>
				<p class="text-sm leading-relaxed sm:text-base text-slate-600">
					Covers liabilities for injury or death to third parties, and
					damage to their property. Does not cover your own vehicle.
				</p>
			</div>
		</div>

		<div
			class="flex flex-col-reverse justify-between gap-4 mt-6 sm:flex-row sm:mt-8"
		>
			<button
				@click="previous"
				class="w-full px-6 py-3 text-base font-semibold text-blue-600 transition-colors duration-300 border-2 border-blue-600 rounded-full sm:w-auto sm:text-lg hover:bg-blue-50"
			>
				Back
			</button>
			<button
				@click="next"
				:disabled="!selectedCoverType"
				:class="[
					'w-full sm:w-auto px-6 py-3 text-base sm:text-lg rounded-full text-white font-semibold shadow-lg transition-colors duration-300',
					selectedCoverType
						? 'bg-blue-600 hover:bg-blue-700'
						: 'bg-gray-400 cursor-not-allowed',
				]"
			>
				Continue
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CommercialCoverTypeSelection',
	data() {
		return {
			selectedCoverType: null,
		};
	},
	methods: {
		selectCover(coverType) {
			this.selectedCoverType = coverType;
		},
		next() {
			// Logic to navigate to the next step, e.g., 'CommercialVehicleValuation'
			this.$emit('next', { coverType: this.selectedCoverType });
		},
		previous() {
			// Logic to navigate to the previous step
			this.$emit('previous');
		},
	},
};
</script>

<style scoped>
/* Scoped styles for this component */
</style>
